import React, { useId, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { searchProducts, fromPrice } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
export function SearchBox({
  onNavigate
}: {
  onNavigate?: () => void;
}) {
  const id = useId();
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();
  const results = searchProducts(query);
  const showPanel = focused && query.trim().length > 0;
  const go = (slug: string) => {
    navigate(`/product/${slug}`);
    setQuery('');
    setFocused(false);
    onNavigate?.();
  };
  return <form role="search" className="relative w-full" onSubmit={e => {
    e.preventDefault();
    if (results[0]) go(results[0].slug);
  }} data-id="element-244" data-mp="2dbme5b0635en">
      <label htmlFor={id} className="sr-only" data-id="element-245" data-mp="15vy7k9tkornj">Zoek producten</label>
      <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-246" data-mp="11vo351lfi9as" />
      <input id={id} type="search" value={query} autoComplete="off" onChange={e => setQuery(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onKeyDown={e => e.key === 'Escape' && setFocused(false)} placeholder="Zoek arganolie, zwarte zeep, kessa…" className="h-11 w-full rounded-full border border-line bg-white pl-11 pr-4 text-sm text-ink placeholder:text-muted focus:border-ink focus:outline-none" data-id="element-247" data-mp="xg1tfol32efn" />
      {showPanel && <div className="absolute inset-x-0 top-full z-50 mt-2 overflow-hidden rounded-2xl border border-line bg-white shadow-[0_16px_40px_-16px_rgba(28,23,20,0.25)]" data-id="element-248" data-mp="4u8s7jffr7uz">
          {results.length === 0 ? <p className="px-4 py-5 text-sm text-muted" data-id="element-249" data-mp="3rz84tddb5tfp">Geen producten gevonden voor “{query}”.</p> : <ul data-id="element-250" data-mp="rcd42p3ttvs">
              {results.map(p => <li key={p.slug} data-id="element-251" data-mp="22grr9wu5s2s8">
                  <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => go(p.slug)} className="flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors duration-150 hover:bg-canvas" data-id="element-252" data-mp="22htawpp8pxlk">
                    <img src={p.image} alt="" className="h-11 w-11 rounded-lg bg-surface object-cover" data-id="element-253" data-mp="1orhgul93hors" />
                    <span className="flex-1" data-id="element-254" data-mp="2ldt76cp93nay">
                      <span className="block text-sm font-medium text-ink" data-id="element-255" data-mp="2ggat67wdmhw3">{p.name}</span>
                      <span className="block text-xs text-muted" data-id="element-256" data-mp="2cepnp7m695vx">{p.subtitle}</span>
                    </span>
                    <span className="text-sm font-medium text-ink" data-id="element-257" data-mp="27gxk3gc5zvbw">{formatPrice(fromPrice(p))}</span>
                  </button>
                </li>)}
            </ul>}
        </div>}
    </form>;
}